var render = function render(){var _vm=this,_c=_vm._self._c;return _c('IconBase',{attrs:{"icon-name":"close","width":"26","height":"26","viewBox":"0 0 30 30","title":"Закрыть","no-divider":true},nativeOn:{"click":function($event){return _vm.closeFilters.apply(null, arguments)}}},[_c('IconClose')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }